import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.xray.normality_review_runtime_v12');
import { OnInit, Input } from '@angular/core';

@Component({ standalone: false,
    selector: 'wiz-page-xray-normality_review_runtime_v12',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.xray.normality_review_runtime_v12/view.scss */
/* src/app/page.xray.normality_review_runtime_v12/view.scss: no such file or directory */`],
})
export class PageXrayNormality_review_runtime_v12Component implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default PageXrayNormality_review_runtime_v12Component;